export const RECEIPT_EXPORT_COLUMNS: string[] = [
  "Receipt No",
  "Invoice No",
  "Deposit Date",
  "Cheque Date",
  "Bounce Date",
  "Property",
  "Tenant Name",
  "Unit Number",
  "Unit Code",
  "Due Date",
  "Payment Type",
  "Payment Mode",
  "Bank Name",
  "Payment Ref",
  "Amount",
  "VAT",
  "VAT %",
  "Total Amount",
  "Balance",
  "Receipt Date",
  "Payment Status",
  "Reason",
  "Beneficiary Name",
  "Lessor Name",
  "Beneficiary Bank",
  "Beneficiary Account",
  "Beneficiary IBAN",
  "Period To",
  "Period From",
  "Credit Note No",
  "ERP Inv No",
  "Send Status",
];
